import React from "react";
import FlixbusLogo from "../../../assets/images/flixbus.jpg";
import FreeleticsLogo from "../../../assets/images/freeletics.jpg";
import ReadlyLogo from "../../../assets/images/readly.jpg";
import BookingLogo from "../../../assets/images/booking.jpg";
import GetyourguideLogo from "../../../assets/images/getyourguide.jpg";
import GroverLogo from "../../../assets/images/grover.jpg";

function Single({ Image, text, smallText }) {
  return (
    <div className="flex flex-col items-center justify-center space-y-1 border p-1 rounded m-2">
      <img
        className="w-12 h-12 md:w-24 md:h-24  rounded-full"
        src={Image}
        alt=""
      />
      <p className="w-16 truncate md:w-32 text-center">{text}</p>
      <small>{smallText}</small>
    </div>
  );
}

const Intergrations = () => {
  return (
    <div>
      <h1 className="py-6 text-xl">Intergrations</h1>
      <div className="shadow-2xl flex flex-wrap justify-center items-center py-4">
        <Single text="Flixbus" Image={FlixbusLogo} smallText="10% of" />
        <Single text="Freeletics" Image={FreeleticsLogo} smallText="2 month" />
        <Single text="Readly" Image={ReadlyLogo} smallText="20% off" />
        <Single text="Booking" Image={BookingLogo} smallText="4% off" />
        <Single
          text="Getyourguide"
          Image={GetyourguideLogo}
          smallText="8% off"
        />
        <Single text="Grover" Image={GroverLogo} smallText="10% off" />
        <Single text="Flixbus" Image={FlixbusLogo} smallText="10% of" />
        <Single text="Freeletics" Image={FreeleticsLogo} smallText="2 month" />
        <Single text="Readly" Image={ReadlyLogo} smallText="20% off" />
        <Single text="Booking" Image={BookingLogo} smallText="4% off" />
        <Single
          text="Getyourguide"
          Image={GetyourguideLogo}
          smallText="8% off"
        />
        <Single text="Grover" Image={GroverLogo} smallText="10% off" />
      </div>
    </div>
  );
};

export default Intergrations;
